import cn from 'classnames'
import { FC, useCallback, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { ICONS, InfoBlockRounded, InfoBlockSize, InfoBlockType } from './configs'
import { IInfoBlockProps } from './models'

import styles from './InfoBlock.module.scss'

export const InfoBlock: FC<IInfoBlockProps> = ({
  hasIcon = true,
  paddingSize = InfoBlockSize.Medium,
  text,
  type = InfoBlockType.Info,
  customIconClass,
  rounded = InfoBlockRounded.None,
  hasCloseButton,
  replaceParams,
}) => {
  const [isHidden, setIsHidden] = useState(false)
  const content = useMemo(() => {
    if (typeof text === 'string') {
      return <Translation text={text} replaceParams={replaceParams} span htmlAvailable />
    }
    return text
  }, [replaceParams, text])

  const onCloseHandler = useCallback(() => {
    setIsHidden(true)
  }, [])

  if (isHidden) {
    return null
  }

  return (
    <div
      className={cn(
        styles.container,
        styles.borderRadius,
        styles[type],
        styles[paddingSize],
        styles[rounded]
      )}
    >
      {hasIcon && <i className={cn(styles.icon, customIconClass || ICONS[type])} />}
      <div className={cn(styles.content, styles[paddingSize])}>{content}</div>
      {hasCloseButton && (
        <div className={cn(styles.button, styles[paddingSize])}>
          <Button
            color="grey"
            variant="text"
            iconButton="kbase kbase-close"
            onClick={onCloseHandler}
          />
        </div>
      )}
    </div>
  )
}
